"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIfWebP = exports.getSpecificRendition = exports.getGifWidth = exports.getGifHeight = exports.getBestVideo = exports.getBestRenditionUrl = exports.getBestRendition = exports.getAltText = exports.getPingbackId = exports.getClientRect = exports.setRenditionScaleUpMaxPixels = exports.bestfit = void 0;
var bestfit_1 = require("./bestfit");
Object.defineProperty(exports, "bestfit", {
  enumerable: true,
  get: function get() {
    return __importDefault(bestfit_1).default;
  }
});
Object.defineProperty(exports, "setRenditionScaleUpMaxPixels", {
  enumerable: true,
  get: function get() {
    return bestfit_1.setRenditionScaleUpMaxPixels;
  }
});
__exportStar(require("./collections"), exports);
var get_client_rect_from_el_1 = require("./get-client-rect-from-el");
Object.defineProperty(exports, "getClientRect", {
  enumerable: true,
  get: function get() {
    return __importDefault(get_client_rect_from_el_1).default;
  }
});
var get_pingback_id_1 = require("./get-pingback-id");
Object.defineProperty(exports, "getPingbackId", {
  enumerable: true,
  get: function get() {
    return __importDefault(get_pingback_id_1).default;
  }
});
var gif_utils_1 = require("./gif-utils");
Object.defineProperty(exports, "getAltText", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getAltText;
  }
});
Object.defineProperty(exports, "getBestRendition", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getBestRendition;
  }
});
Object.defineProperty(exports, "getBestRenditionUrl", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getBestRenditionUrl;
  }
});
Object.defineProperty(exports, "getBestVideo", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getBestVideo;
  }
});
Object.defineProperty(exports, "getGifHeight", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getGifHeight;
  }
});
Object.defineProperty(exports, "getGifWidth", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getGifWidth;
  }
});
Object.defineProperty(exports, "getSpecificRendition", {
  enumerable: true,
  get: function get() {
    return gif_utils_1.getSpecificRendition;
  }
});
__exportStar(require("./log"), exports);
__exportStar(require("./sdk-headers"), exports);
var webp_check_1 = require("./webp-check");
Object.defineProperty(exports, "checkIfWebP", {
  enumerable: true,
  get: function get() {
    return webp_check_1.checkIfWebP;
  }
});